import React from 'react';
import cn from 'classnames';

import Icon from '../Icon';
import arrow from 'assets/svg/arrow.svg';
import './MarketRowToggler.scss';

interface OwnProps {
    onClick?: () => void;
    rotate?: boolean;
    top?: number;
}

type Props = OwnProps;

/* TODO replace 6px 0 for calculation */
export const MarketRowToggler: React.FC<Props> = ({ onClick, rotate, top }) => (
    <div
        style={top ? { top, margin: '6px 0' } : {}}
        styleName="arrows"
        className="__app-MarketRowToggler-arrows"
        onClick={onClick}
    >
        <Icon glyph={arrow} styleName={cn('arrow', { top: !rotate })} />
        <Icon glyph={arrow} styleName={cn('arrow', { top: rotate })} />
    </div>
);

export default MarketRowToggler;
